import { LINKS } from '@/Module/Core/Constant';
import type { IMobileMenuBarItem } from '@/Module/DefaultLayout/Model';
import {
  IconHomeActive,
  IconHomeUsual,
  IconLearningActive,
  IconLearningUsual,
  IconProfileActive,
  IconProfileUsual,
  IconSearchActive,
  IconSearchUsual,
  IconSubscriptionActive,
  IconSubscriptionUsual,
  IconWorkspaceActive,
  IconWorkspaceDeActive,
} from '@/Module/Icon';

export const beforeData: IMobileMenuBarItem[] = [
  {
    iconUsual: IconHomeUsual,
    iconActive: IconHomeActive,
    link: LINKS.HOME,
    title: 'خانه',
  },
  {
    iconUsual: IconLearningUsual,
    iconActive: IconLearningActive,
    link: LINKS.LEARNING,
    title: 'یادگیری',
  },
  {
    iconUsual: IconSearchUsual,
    iconActive: IconSearchActive,
    link: LINKS.DISCOVER,
    title: 'جستجو',
  },
  {
    iconUsual: IconSubscriptionUsual,
    iconActive: IconSubscriptionActive,
    link: LINKS.SUBSCRIPTION.MAIN,
    title: 'اشتراک',
  },
  {
    iconUsual: IconProfileUsual,
    iconActive: IconProfileActive,
    link: LINKS.AUTH.LOGIN,
    title: 'ورود',
  },
];

export const afterData: IMobileMenuBarItem[] = [
  {
    iconUsual: IconWorkspaceDeActive,
    iconActive: IconWorkspaceActive,
    link: LINKS.WORKSPACE.MAIN,
    title: 'میزکار',
  },
  {
    iconUsual: IconLearningUsual,
    iconActive: IconLearningActive,
    link: LINKS.LEARNING,
    title: 'یادگیری',
  },
  {
    iconUsual: IconSearchUsual,
    iconActive: IconSearchActive,
    link: LINKS.DISCOVER,
    title: 'جستجو',
  },
  {
    iconUsual: IconSubscriptionUsual,
    iconActive: IconSubscriptionActive,
    link: LINKS.PROFILE.SUBSCRIPTION,
    title: 'اشتراک',
  },
  {
    iconUsual: IconProfileUsual,
    iconActive: IconProfileActive,
    link: LINKS.PROFILE.DEFAULT,
    title: 'آی‌نـوی من',
  },
];
